// Inject original runtime classes
document.body.classList.add('loaded')
document.body.classList.add('mobile')
document.documentElement.classList.add('is_dark')

// Inject Swiper/Vant active states after hydration
setTimeout(() => {
  document.querySelectorAll('.swiper-container').forEach(el => {
    el.classList.add('swiper-container-initialized', 'swiper-container-horizontal')
  })
}, 100)

// Scale reflow: force all components to recalculate on new rem baseline
window.addEventListener('load', () => {
  setTimeout(() => {
    // Trigger resize to force rem recalculation
    window.dispatchEvent(new Event('resize'))
    // Force Swiper update after reflow
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        document.querySelectorAll('.swiper-container').forEach(el => {
          if (el.swiper) {
            el.swiper.update()
            el.swiper.updateSize()
            el.swiper.updateSlides()
          }
        })
      })
    })
  }, 300)
})
